import FaqItemContent from "./features/faq/faq-item-content.vue";
import FaqItemTitle from "./features/faq/faq-item-title.vue";
import FaqItem from "./features/faq/faq-item.vue";
import HeaderMenuTrigger from "./components/header-menu-trigger.vue";
import GlobalContainer from "./features/global-container.vue";
import CountryTag from "./components/country-tag.vue";
import ReservationNotificationButton from "./features/reservation/reservation-notification-button.vue";
import { defineAsyncComponent } from "vue";
import HeaderProfile from "@/features/user/header-profile.vue";
import HeaderNavProfile from "@/features/user/header-nav-profile.vue";
import HeaderLangs from "@/features/user/header-langs.vue";
import TimeCounter from "@/features/time-counter/time-counter.vue";
import GiftForm from "@/features/gift/gift-form.vue";
import AuthLink from "@/features/user/auth-link.vue";
import LeaveLink from "@/features/leave-confirmation/leave-link.vue";
import FruitLink from "@/components/fruit-link.vue";
import SubscribeModal from "./features/subscribe/subscribe-modal.vue";
import GrocerySuccess from "./features/grocery/grocery-success.vue";
import ReservationSuccess from "./features/reservation/reservation-success.vue";
// Poland launch contest landing page — temporary, remove with the landing page.
import LandingContestForm from "./features/landing/landing-contest-form.vue";
import LandingWho from "./features/landing/landing-who.vue";
import LandingAccordion from "./features/landing/landing-accordion.vue";
import LandingReviews from "./features/landing/landing-reviews.vue";

export const VIEW_COMPONENTS = {
  HeaderMenuTrigger,
  FaqItem,
  FaqItemTitle,
  FaqItemContent,
  GlobalContainer,
  ReservationNotificationButton,
  CountryTag,
  HeaderProfile,
  HeaderLangs,
  HeaderNavProfile,
  TimeCounter,
  GiftForm,
  AuthLink,
  FruitLink,
  LeaveLink,
  SubscribeModal,
  GrocerySuccess,
  ReservationSuccess,
  LandingContestForm,
  LandingWho,
  LandingAccordion,
  LandingReviews,
  ReservationContainer: defineAsyncComponent(
    () =>
      import(
        /* webpackChunkName: "reservation" */ "@/features/reservation/reservation-container.vue"
      )
  ),
  ReservationHeader: defineAsyncComponent(
    () =>
      import(
        /* webpackChunkName: "reservation" */ "@/features/reservation/reservation-header.vue"
      )
  ),
  ProfileGeneral: defineAsyncComponent(
    () =>
      import(
        /* webpackChunkName: "profile" */ "@/features/profile/profile-general.vue"
      )
  ),
  ProfileOrders: defineAsyncComponent(
    () =>
      import(
        /* webpackChunkName: "profile" */ "@/features/profile/profile-orders.vue"
      )
  ),
  OrderItem: defineAsyncComponent(
    () =>
      import(/* webpackChunkName: "profile" */ "@/components/order-item.vue")
  ),
  ProfilePassword: defineAsyncComponent(
    () =>
      import(
        /* webpackChunkName: "profile" */ "@/features/profile/profile-password.vue"
      )
  ),
  ProfileQuality: defineAsyncComponent(
    () =>
      import(
        /* webpackChunkName: "profile" */ "@/features/profile/profile-quality.vue"
      )
  ),
  ProfileNotifications: defineAsyncComponent(
    () =>
      import(
        /* webpackChunkName: "profile" */ "@/features/profile/profile-notifications.vue"
      )
  ),
  GroceryContainer: defineAsyncComponent(
    () =>
      import(
        /* webpackChunkName: "grocery" */ "@/features/grocery/grocery-container.vue"
      )
  ),
  GroceryHeader: defineAsyncComponent(
    () =>
      import(
        /* webpackChunkName: "grocery" */ "@/features/grocery/grocery-header.vue"
      )
  ),
  ContactModal: defineAsyncComponent(
    () =>
      import(
        /* webpackChunkName: "organizations" */ "@/features/organizations/contact-modal.vue"
      )
  ),
};
